export default __webpack_public_path__ + "static/media/oneBottomLeft.4666a996.png";